import { Record, Union } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { record_type, list_type, string_type, bool_type, option_type, union_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Role, Role__ToDescription, MyHistory_$reflection } from "../Shared/SharedModels.jsx";
import { filter, append as append_1, contains, singleton as singleton_1, ofArray, empty } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { tap, PromiseBuilder__TryFinally_7D49A2FD, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Task, toastServerError, Event$ } from "../ApiClient.jsx";
import { successToast, errorToast } from "../Toasts.jsx";
import { month, year, getTicks } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { nb } from "date-fns/locale";
import { format as format_1 } from "date-fns";
import { join, isNullOrWhiteSpace, printf, toText, substring, isNullOrEmpty } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { createElement } from "react";
import React from "react";
import { DialogActions, DialogContent, DialogTitle, DialogBody, DialogSurface, Dialog, SkeletonItem, Skeleton, AccordionPanel, AccordionHeader, AccordionItem, Accordion, Divider, Input, Link, Tag, Body1, Badge, Body1Strong, Button, Tooltip, Avatar, Caption1, Title3, tokens, Caption1Strong, Card } from "@fluentui/react-components";
import { stringHash, comparePrimitives, numberHash, equals, int32ToString, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { take, length, collect, empty as empty_1, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { map as map_1, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { WarningRegular, ArrowRightRegular, WeatherSunnyLowRegular, ArrowSortDownLinesRegular, ArrowSortUpLinesRegular, SearchRegular, CircleHintHalfVerticalRegular, CheckmarkCircleRegular, CalendarLtrRegular, DocumentRegular, CheckmarkRegular, DocumentCheckmarkRegular, DeleteRegular } from "@fluentui/react-icons";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { mapIndexed, item, sortBy, sumBy, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { compare, op_UnaryNegation, toInt64 } from "../fable_modules/fable-library-js.4.29.0/BigInt.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { dataFetchFailedView } from "../Helpers.jsx";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";

class SortOrder extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Newest", "Oldest"];
    }
}

function SortOrder_$reflection() {
    return union_type("Event.ListCompletedEvents.SortOrder", [], SortOrder, () => [[], []]);
}

class Model extends Record {
    constructor(History, IsFetching, Search, Sort, OpenItems) {
        super();
        this.History = History;
        this.IsFetching = IsFetching;
        this.Search = Search;
        this.Sort = Sort;
        this.OpenItems = OpenItems;
    }
}

function Model_$reflection() {
    return record_type("Event.ListCompletedEvents.Model", [], Model, () => [["History", option_type(MyHistory_$reflection())], ["IsFetching", bool_type], ["Search", string_type], ["Sort", SortOrder_$reflection()], ["OpenItems", list_type(string_type)]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateHistory", "UpdateIsFetching", "UpdateSearch", "UpdateSort", "UpdateOpenItems"];
    }
}

function Msg_$reflection() {
    return union_type("Event.ListCompletedEvents.Msg", [], Msg, () => [[["Item", option_type(MyHistory_$reflection())]], [["Item", bool_type]], [["Item", string_type]], [["Item", SortOrder_$reflection()]], [["Item", list_type(string_type)]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.History, msg.fields[0], model.Search, model.Sort, model.OpenItems);
        case 2:
            return new Model(model.History, model.IsFetching, msg.fields[0], model.Sort, model.OpenItems);
        case 3:
            return new Model(model.History, model.IsFetching, model.Search, msg.fields[0], model.OpenItems);
        case 4:
            return new Model(model.History, model.IsFetching, model.Search, model.Sort, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.IsFetching, model.Search, model.Sort, model.OpenItems);
    }
}

function init() {
    return new Model(undefined, true, "", new SortOrder(0, []), empty());
}

function fetchHistory(userId, dispatch, setCtx) {
    let pr_1;
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__TryFinally_7D49A2FD(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (startAsPromise(Event$.GetHistory(userId)).then((_arg) => {
        const result = _arg;
        if (result.tag === 1) {
            errorToast(setCtx, "fetchHistoryError", "Kunne ikke hente historikk", "", undefined);
            return Promise.resolve();
        }
        else {
            dispatch(new Msg(0, [result.fields[0]]));
            return Promise.resolve();
        }
    }))), () => {
        dispatch(new Msg(1, [false]));
    })));
    pr_1 = (pr.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
    void pr_1;
}

function entryKey(entry) {
    if (entry.tag === 1) {
        const c = entry.fields[0];
        return `i${c.Task.Id}-${getTicks(c.Completed)}`;
    }
    else {
        return `e${entry.fields[0].Event.Id}`;
    }
}

function entryDate(entry) {
    if (entry.tag === 1) {
        return entry.fields[0].Completed;
    }
    else {
        return entry.fields[0].Event.Time;
    }
}

function monthKey(d) {
    return (year(d) * 100) + month(d);
}

function monthLabel(d) {
    let label;
    const locale = nb;
    const formatOptions = {};
    formatOptions.locale = locale;
    label = format_1(d, "MMMM yyyy", formatOptions);
    if (isNullOrEmpty(label)) {
        return label;
    }
    else {
        return label[0].toLocaleUpperCase() + substring(label, 1);
    }
}

function granterName(g) {
    return `${g.FirstName} ${g.LastName}`;
}

function KpiTile(kpiTileInputProps) {
    let elems_1, el, elems;
    const accent = kpiTileInputProps.accent;
    const sub = kpiTileInputProps.sub;
    const value = kpiTileInputProps.value;
    const label = kpiTileInputProps.label;
    const el_6 = Card;
    return createElement(el_6, createObj(ofArray([["style", {
        padding: ((14 + "px") + " ") + (18 + "px"),
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
        minHeight: 72 + "px",
    }], (elems_1 = [(el = Caption1Strong, createElement(el, {
        style: {
            color: tokens.colorNeutralForeground3,
            textTransform: "uppercase",
            letterSpacing: 1,
        },
        children: label,
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "baseline",
        gap: 8 + "px ",
    }], (elems = toList(delay(() => {
        let el_2;
        return append(singleton((el_2 = Title3, createElement(el_2, {
            style: {
                color: defaultArg(accent, tokens.colorNeutralForeground1),
            },
            children: value,
        }))), delay(() => {
            let el_4;
            return (sub !== "") ? singleton((el_4 = Caption1, createElement(el_4, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: sub,
            }))) : empty_1();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])])));
}

function CompactDateLabel(compactDateLabelInputProps) {
    let locale, formatOptions;
    const compact = compactDateLabelInputProps.compact;
    const d = compactDateLabelInputProps.d;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            color: tokens.colorNeutralForeground3,
            minWidth: compact ? 44 : 56,
            flexShrink: 0,
            textAlign: "center",
        },
        children: ((locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(d, "dd. MMM", formatOptions))))).toLocaleUpperCase(),
    });
}

function GranterChip(g) {
    let elems, el, el_2, el_4;
    const name = granterName(g);
    return createElement("span", createObj(ofArray([["style", {
        display: "inline-flex",
        alignItems: "center",
        gap: 6 + "px ",
    }], (elems = [(el = Avatar, createElement(el, {
        color: "colorful",
        size: 20,
        name: name,
        image: {
            src: defaultArg(g.ThumbnailUrl, ""),
        },
    })), (el_2 = Caption1Strong, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground2,
        },
        children: name,
    })), (el_4 = Caption1, createElement(el_4, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `· ${Role__ToDescription(g.Role)}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function DeleteCompletionButton(c, onRequestDelete) {
    let el_2, el;
    const el_4 = Tooltip;
    return createElement(el_4, {
        content: "Fjern fullføring",
        relationship: "label",
        children: (el_2 = Button, createElement(el_2, {
            appearance: "subtle",
            size: "small",
            icon: (el = DeleteRegular, createElement(el, {})),
            onClick: (e) => {
                e.stopPropagation();
                onRequestDelete(c);
            },
        })),
    });
}

function TaskApprovedRow(taskApprovedRowInputProps) {
    let elems_3;
    const onRequestDelete = taskApprovedRowInputProps.onRequestDelete;
    const canDelete = taskApprovedRowInputProps.canDelete;
    const c = taskApprovedRowInputProps.c;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 14 + "px ",
        padding: ((11 + "px") + " ") + (14 + "px"),
        borderTop: (((1 + "px ") + "dashed") + " ") + tokens.colorNeutralStroke2,
        backgroundColor: tokens.colorNeutralBackground2,
    }], (elems_3 = toList(delay(() => {
        let elems_2, elems, el, el_2, elems_1;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 4 + "px ",
            flexGrow: 1,
            minWidth: 0,
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 10 + "px ",
            flexWrap: "wrap",
        }], (elems = [(el = DocumentCheckmarkRegular, createElement(el, {
            fontSize: 16,
            primaryFill: tokens.colorPaletteGreenForeground1,
        })), (el_2 = Body1Strong, createElement(el_2, {
            style: {
                color: tokens.colorNeutralForeground1,
            },
            children: c.Task.Name,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 6 + "px ",
            flexWrap: "wrap",
        }], (elems_1 = toList(delay(() => {
            let el_4, arg, locale, formatOptions;
            return append(singleton((el_4 = Caption1, createElement(el_4, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: (arg = ((locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(c.Completed, "dd. MMM yyyy", formatOptions))))), toText(printf("Godkjent %s av"))(arg)),
            }))), delay(() => {
                let el_6;
                const matchValue = c.GrantedBy;
                return (matchValue == null) ? singleton((el_6 = Caption1, createElement(el_6, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: "ukjent",
                }))) : singleton(createElement(GranterChip, matchValue));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let el_10, el_8;
            return append(singleton((el_10 = Badge, createElement(el_10, {
                appearance: "tint",
                color: "success",
                icon: (el_8 = CheckmarkRegular, createElement(el_8, {})),
                children: "Godkjent",
            }))), delay(() => (canDelete ? singleton(DeleteCompletionButton(c, onRequestDelete)) : empty_1())));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function TaskMissingRow(t) {
    let elems, el, el_2, el_4;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        padding: ((11 + "px") + " ") + (14 + "px"),
        borderTop: (((1 + "px ") + "dashed") + " ") + tokens.colorNeutralStroke2,
        backgroundColor: tokens.colorNeutralBackground2,
    }], (elems = [(el = DocumentRegular, createElement(el, {
        fontSize: 16,
        primaryFill: tokens.colorNeutralForeground3,
    })), (el_2 = Body1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground2,
            flexGrow: 1,
        },
        children: t.Name,
    })), (el_4 = Badge, createElement(el_4, {
        appearance: "tint",
        color: "warning",
        children: "Mangler",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function EventHeaderContent(eventHeaderContentInputProps) {
    let elems_4;
    const isMobile = eventHeaderContentInputProps.isMobile;
    const ev = eventHeaderContentInputProps.ev;
    const totalTasks = (ev.CompletedTasks.length + ev.MissingTasks.length) | 0;
    const givenTasks = ev.CompletedTasks.length | 0;
    const pendingTasks = ev.MissingTasks.length | 0;
    const patternInput = (totalTasks === 0) ? ["Ingen oppgaver", tokens.colorNeutralForeground3] : ((pendingTasks === 0) ? [toText(printf("%d av %d oppgaver godkjent"))(givenTasks)(totalTasks), tokens.colorPaletteGreenForeground1] : [toText(printf("%d av %d oppgaver godkjent"))(givenTasks)(totalTasks), tokens.colorPaletteMarigoldForeground1]);
    const summaryText = patternInput[0];
    const summaryColor = patternInput[1];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 14 + "px ",
        width: 100 + "%",
        minWidth: 0,
    }], (elems_4 = toList(delay(() => append(singleton(createElement(CompactDateLabel, {
        d: ev.Event.Time,
        compact: isMobile,
    })), delay(() => {
        let elems_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 4 + "px ",
            flexGrow: 1,
            minWidth: 0,
        }], (elems_2 = toList(delay(() => {
            let elems, el, el_4, el_2;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 8 + "px ",
                flexWrap: "wrap",
            }], (elems = [(el = Body1Strong, createElement(el, {
                style: {
                    color: tokens.colorNeutralForeground1,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                },
                children: ev.Event.Name,
            })), (el_4 = Tag, createElement(el_4, {
                size: "small",
                appearance: "brand",
                shape: "circular",
                icon: (el_2 = CalendarLtrRegular, createElement(el_2, {})),
                primaryText: "Arrangement",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
                let elems_1, el_6;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 8 + "px ",
                    flexWrap: "wrap",
                }], (elems_1 = [(el_6 = Caption1, createElement(el_6, {
                    style: {
                        color: tokens.colorNeutralForeground3,
                    },
                    children: ev.Event.Course.Name,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                    let el_8;
                    return isMobile ? singleton((el_8 = Caption1Strong, createElement(el_8, {
                        style: {
                            color: summaryColor,
                        },
                        children: summaryText,
                    }))) : empty_1();
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3;
            return !isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 6 + "px ",
                minWidth: 220,
                justifyContent: "flex-end",
            }], (elems_3 = toList(delay(() => {
                let el_10, el_12;
                return append((totalTasks > 0) ? ((pendingTasks === 0) ? singleton((el_10 = CheckmarkCircleRegular, createElement(el_10, {
                    fontSize: 16,
                    primaryFill: tokens.colorPaletteGreenForeground1,
                }))) : singleton((el_12 = CircleHintHalfVerticalRegular, createElement(el_12, {
                    fontSize: 16,
                    primaryFill: tokens.colorPaletteMarigoldForeground1,
                })))) : empty_1(), delay(() => {
                    let el_14;
                    return singleton((el_14 = Caption1Strong, createElement(el_14, {
                        style: {
                            color: summaryColor,
                        },
                        children: summaryText,
                    })));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : empty_1();
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function EventPanelContent(eventPanelContentInputProps) {
    let elems_3;
    const onRequestDelete = eventPanelContentInputProps.onRequestDelete;
    const canDelete = eventPanelContentInputProps.canDelete;
    const ev = eventPanelContentInputProps.ev;
    const totalTasks = (ev.CompletedTasks.length + ev.MissingTasks.length) | 0;
    return createElement("div", createObj(singleton_1((elems_3 = toList(delay(() => {
        let elems, el_2, el;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            padding: ((10 + "px") + " ") + (14 + "px"),
        }], (elems = [(el_2 = Link, createElement(el_2, {
            href: RouterModule_encodeParts(ofArray(["arrangement", int32ToString(ev.Event.Id)]), 1),
            children: (el = Body1, createElement(el, {
                children: "Åpne arrangement",
            })),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1, elems_2, el_4;
            return (totalTasks > 0) ? singleton(createElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append(map((c) => createElement(TaskApprovedRow, {
                c: c,
                canDelete: canDelete,
                onRequestDelete: onRequestDelete,
            }), ev.CompletedTasks), delay(() => map((t) => createElement(TaskMissingRow, t), ev.MissingTasks))))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))))) : singleton(createElement("div", createObj(ofArray([["style", {
                padding: ((14 + "px") + " ") + (18 + "px"),
                borderTop: (((1 + "px ") + "dashed") + " ") + tokens.colorNeutralStroke2,
                backgroundColor: tokens.colorNeutralBackground2,
            }], (elems_2 = [(el_4 = Caption1, createElement(el_4, {
                style: {
                    color: tokens.colorNeutralForeground3,
                    fontStyle: "italic",
                },
                children: "Ingen oppgaver var knyttet til dette arrangementet.",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))]))));
}

function IsolatedRow(isolatedRowInputProps) {
    let elems_2;
    const onRequestDelete = isolatedRowInputProps.onRequestDelete;
    const canDelete = isolatedRowInputProps.canDelete;
    const isMobile = isolatedRowInputProps.isMobile;
    const c = isolatedRowInputProps.c;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        padding: ((8 + "px") + " ") + (14 + "px"),
    }], (elems_2 = toList(delay(() => append(singleton(createElement(CompactDateLabel, {
        d: c.Completed,
        compact: isMobile,
    })), delay(() => {
        let elems;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
            flexWrap: "wrap",
            flexGrow: 1,
            minWidth: 0,
        }], (elems = toList(delay(() => {
            let el;
            return append(singleton((el = Body1Strong, createElement(el, {
                style: {
                    color: tokens.colorNeutralForeground1,
                },
                children: c.Task.Name,
            }))), delay(() => {
                let el_4, el_2;
                return append(singleton((el_4 = Tag, createElement(el_4, {
                    size: "small",
                    appearance: "brand",
                    shape: "circular",
                    icon: (el_2 = DocumentCheckmarkRegular, createElement(el_2, {})),
                    primaryText: "Oppgave",
                }))), delay(() => {
                    let el_8, el_6;
                    if (!isMobile) {
                        const matchValue = c.GrantedBy;
                        if (matchValue == null) {
                            return singleton((el_8 = Caption1, createElement(el_8, {
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: "av ukjent",
                            })));
                        }
                        else {
                            const g = matchValue;
                            return append(singleton((el_6 = Caption1, createElement(el_6, {
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: "av",
                            }))), delay(() => singleton(createElement(GranterChip, g))));
                        }
                    }
                    else {
                        return empty_1();
                    }
                }));
            }));
        })), ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1, el_10, el_12;
            return append(!isMobile ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                gap: 6 + "px ",
                justifyContent: "flex-end",
                minWidth: 220,
            }], (elems_1 = [(el_10 = CheckmarkCircleRegular, createElement(el_10, {
                fontSize: 16,
                primaryFill: tokens.colorPaletteGreenForeground1,
            })), (el_12 = Caption1Strong, createElement(el_12, {
                style: {
                    color: tokens.colorPaletteGreenForeground1,
                },
                children: "Godkjent",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty_1(), delay(() => (canDelete ? singleton(DeleteCompletionButton(c, onRequestDelete)) : empty_1())));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function matchesSearch(q, entry) {
    if (isNullOrWhiteSpace(q)) {
        return true;
    }
    else {
        const q_1 = q.toLocaleLowerCase();
        if (entry.tag === 1) {
            const c_2 = entry.fields[0];
            if (c_2.Task.Name.toLocaleLowerCase().indexOf(q_1) >= 0) {
                return true;
            }
            else {
                const matchValue_1 = c_2.GrantedBy;
                if (matchValue_1 == null) {
                    return false;
                }
                else {
                    const g_1 = matchValue_1;
                    return granterName(g_1).toLocaleLowerCase().indexOf(q_1) >= 0;
                }
            }
        }
        else {
            const ev = entry.fields[0];
            if ((((ev.Event.Name.toLocaleLowerCase().indexOf(q_1) >= 0) ? true : (ev.Event.Course.Name.toLocaleLowerCase().indexOf(q_1) >= 0)) ? true : ev.CompletedTasks.some((c) => (c.Task.Name.toLocaleLowerCase().indexOf(q_1) >= 0))) ? true : ev.MissingTasks.some((t) => (t.Name.toLocaleLowerCase().indexOf(q_1) >= 0))) {
                return true;
            }
            else {
                return ev.CompletedTasks.some((c_1) => {
                    const matchValue = c_1.GrantedBy;
                    if (matchValue == null) {
                        return false;
                    }
                    else {
                        const g = matchValue;
                        return granterName(g).toLocaleLowerCase().indexOf(q_1) >= 0;
                    }
                });
            }
        }
    }
}

export function View(viewInputProps) {
    let elems_24;
    const userId = viewInputProps.userId;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const canDelete = equals(ctx.User.Role, new Role(1, [])) && (ctx.User.Id !== userId);
    const patternInput_2 = reactApi.useState(undefined);
    const setPendingDelete = patternInput_2[1];
    const pendingDelete = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsDeleting = patternInput_3[1];
    const isDeleting = patternInput_3[0];
    const dependencies = [userId];
    reactApi.useEffect(() => {
        fetchHistory(userId, dispatch, setCtx);
    }, dependencies);
    const requestDelete = (c) => {
        setPendingDelete(c);
    };
    const entries = defaultArg(map_1((_arg) => _arg.Entries, model_1.History), []);
    const attendedCount = sumBy((e_1) => {
        if (e_1.tag === 0) {
            return 1;
        }
        else {
            return 0;
        }
    }, entries, {
        GetZero: () => 0,
        Add: (x, y) => (x + y),
    }) | 0;
    const pendingTaskCount = sumBy((e_2) => {
        if (e_2.tag === 1) {
            return 0;
        }
        else {
            return e_2.fields[0].MissingTasks.length | 0;
        }
    }, entries, {
        GetZero: () => 0,
        Add: (x_1, y_1) => (x_1 + y_1),
    }) | 0;
    const filtered = sortBy((e_3) => {
        if (model_1.Sort.tag === 1) {
            return getTicks(entryDate(e_3));
        }
        else {
            return toInt64(op_UnaryNegation(getTicks(entryDate(e_3))));
        }
    }, entries.filter((entry) => matchesSearch(model_1.Search, entry)), {
        Compare: compare,
    });
    const grouped = map((tupledArg_1) => {
        const items = tupledArg_1[1];
        return [monthLabel(entryDate(item(0, items))), items];
    }, sortBy((tupledArg) => {
        const k = tupledArg[0] | 0;
        if (model_1.Sort.tag === 1) {
            return k | 0;
        }
        else {
            return op_UnaryNegation_Int32(k) | 0;
        }
    }, Array_groupBy((e_4) => monthKey(entryDate(e_4)), filtered, {
        Equals: (x_3, y_3) => (x_3 === y_3),
        GetHashCode: numberHash,
    }), {
        Compare: comparePrimitives,
    }));
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 1.5 + "rem",
    }], (elems_24 = toList(delay(() => {
        let elems, el, el_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 4 + "px ",
        }], (elems = [(el = Title3, createElement(el, {
            children: "Mine kurs og oppgaver",
        })), (el_2 = Caption1, createElement(el_2, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Kronologisk oversikt over arrangement du har deltatt på og oppgaver du har fått godkjent.",
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_1;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "grid",
                gridTemplateColumns: join(" ", [1 + "fr", 1 + "fr"]),
                gap: 12 + "px ",
            }], (elems_1 = [createElement(KpiTile, {
                label: "Arrangement deltatt",
                value: int32ToString(attendedCount),
                sub: "totalt",
            }), createElement(KpiTile, {
                label: "Mangler godkjenning",
                value: int32ToString(pendingTaskCount),
                sub: (pendingTaskCount > 0) ? "oppgaver" : "alt klart",
                accent: (pendingTaskCount > 0) ? tokens.colorPaletteMarigoldForeground1 : tokens.colorPaletteGreenForeground1,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
                let elems_4, elems_3;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 10 + "px ",
                }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 10 + "px ",
                    alignItems: "center",
                    flexWrap: "wrap",
                }], (elems_3 = toList(delay(() => {
                    let elems_2, el_6, el_4;
                    return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["flexGrow", 1]), delay(() => append(!isMobile ? singleton(["maxWidth", 360]) : empty_1(), delay(() => singleton(["minWidth", 200]))))))))], (elems_2 = [(el_6 = Input, createElement(el_6, {
                        contentBefore: (el_4 = SearchRegular, createElement(el_4, {})),
                        placeholder: "Søk i arrangement, oppgaver eller lærer",
                        value: model_1.Search,
                        style: {
                            width: 100 + "%",
                        },
                        onChange: (_arg_3, value_1_5) => {
                            dispatch(new Msg(2, [value_1_5.value]));
                        },
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(!isMobile ? singleton(createElement("div", {
                        style: {
                            flexGrow: 1,
                        },
                    })) : empty_1(), delay(() => {
                        let el_10, el_8, el_14, el_12;
                        const patternInput_4 = (model_1.Sort.tag === 1) ? [new SortOrder(0, []), "Eldste først", (el_10 = ArrowSortUpLinesRegular, createElement(el_10, {}))] : [new SortOrder(1, []), "Nyeste først", (el_8 = ArrowSortDownLinesRegular, createElement(el_8, {}))];
                        return singleton((el_14 = Tooltip, createElement(el_14, {
                            content: patternInput_4[1],
                            relationship: "label",
                            children: (el_12 = Button, createElement(el_12, {
                                appearance: "subtle",
                                size: "small",
                                icon: patternInput_4[2],
                                onClick: (_arg_4) => {
                                    dispatch(new Msg(3, [patternInput_4[0]]));
                                },
                            })),
                        })));
                    }))));
                })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let el_24, elems_6, el_20, el_22, elems_8, el_26, el_28, el_30, el_36, elems_7, el_34, el_32, elems_15, el_18, elems_5;
                    return append((model_1.History != null) ? (((filtered.length === 0) && (entries.length > 0)) ? singleton((el_24 = Card, createElement(el_24, createObj(ofArray([["style", {
                        padding: 32,
                        alignItems: "center",
                        textAlign: "center",
                    }], (elems_6 = [(el_20 = Body1Strong, createElement(el_20, {
                        children: "Ingen arrangement matcher",
                    })), (el_22 = Caption1, createElement(el_22, {
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: "Prøv et annet søk eller fjern filtre.",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])]))))) : ((entries.length === 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: 8 + "px ",
                        padding: 32,
                    }], (elems_8 = [(el_26 = WeatherSunnyLowRegular, createElement(el_26, {
                        primaryFill: tokens.colorBrandForeground1,
                        style: {
                            fontSize: 96 + "px",
                        },
                    })), (el_28 = Body1Strong, createElement(el_28, {
                        children: "Du har ingen historikk enda",
                    })), (el_30 = Caption1, createElement(el_30, {
                        style: {
                            color: tokens.colorNeutralForeground3,
                        },
                        children: "Arrangement du deltar på vil vises her etter at de er gjennomført.",
                    })), (el_36 = Link, createElement(el_36, createObj(ofArray([["href", RouterModule_encodeParts(singleton_1("arrangement"), 1)], (elems_7 = [(el_34 = Button, createElement(el_34, {
                        appearance: "subtle",
                        icon: (el_32 = ArrowRightRegular, createElement(el_32, {})),
                        iconPosition: "after",
                        children: "Se kommende arrangement",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 18 + "px ",
                    }], (elems_15 = toList(delay(() => collect((matchValue_5) => {
                        let elems_14, el_38, el_48, elems_13, elems_12;
                        return singleton(createElement("section", createObj(singleton_1((elems_14 = [(el_38 = Caption1Strong, createElement(el_38, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                                textTransform: "uppercase",
                                letterSpacing: 1,
                                display: "block",
                                padding: ((((((4 + "px") + " ") + (4 + "px")) + " ") + (8 + "px")) + " ") + (4 + "px"),
                            },
                            children: matchValue_5[0],
                        })), (el_48 = Card, createElement(el_48, createObj(ofArray([["style", {
                            gap: 0 + "px ",
                            overflow: "hidden",
                        }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 5 + "px ",
                        }], (elems_12 = toList(delay(() => collect((matchValue_6) => {
                            let el_40;
                            const entry_1 = matchValue_6[1];
                            return append((matchValue_6[0] > 0) ? singleton((el_40 = Divider, createElement(el_40, {
                                appearance: "subtle",
                            }))) : empty_1(), delay(() => {
                                let el_46, value_167, elems_11, el_44, elems_10, el_42, elems_9, props_70, name_14;
                                const matchValue_7 = entry_1;
                                if (matchValue_7.tag === 1) {
                                    return singleton(createElement(IsolatedRow, {
                                        c: matchValue_7.fields[0],
                                        isMobile: isMobile,
                                        canDelete: canDelete,
                                        onRequestDelete: requestDelete,
                                    }));
                                }
                                else {
                                    const ev_1 = matchValue_7.fields[0];
                                    const key_143 = entryKey(entry_1);
                                    return singleton((el_46 = Accordion, createElement(el_46, createObj(ofArray([["collapsible", true], (value_167 = (contains(key_143, model_1.OpenItems, {
                                        Equals: (x_5, y_5) => (x_5 === y_5),
                                        GetHashCode: stringHash,
                                    }) ? singleton_1(key_143) : empty()), ["openItems", Array.from(value_167)]), ["onToggle", (_arg_5, value_1_18) => {
                                        const opens = ofArray(value_1_18.openItems);
                                        dispatch(new Msg(4, [append_1(filter((k_1) => (k_1 !== key_143), model_1.OpenItems), opens)]));
                                    }], (elems_11 = [(el_44 = AccordionItem, createElement(el_44, createObj(ofArray([["value", key_143], (elems_10 = [(el_42 = AccordionHeader, createElement(el_42, createObj(ofArray([["expandIconPosition", "end"], (elems_9 = [createElement(EventHeaderContent, {
                                        ev: ev_1,
                                        isMobile: isMobile,
                                    })], ["children", reactApi_1.Children.toArray(Array.from(elems_9))])])))), (props_70 = singleton_1(createElement(EventPanelContent, {
                                        ev: ev_1,
                                        canDelete: canDelete,
                                        onRequestDelete: requestDelete,
                                    })), (name_14 = AccordionPanel, createElement(name_14, {
                                        children: reactApi.Children.toArray(Array.from(props_70)),
                                    })))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])])))));
                                }
                            }));
                        }, mapIndexed((i_1, e_5) => [i_1, e_5], matchValue_5[1])))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_14))])))));
                    }, grouped))), ["children", reactApi.Children.toArray(Array.from(elems_15))])])))))) : (model_1.IsFetching ? singleton((el_18 = Skeleton, createElement(el_18, createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 12 + "px ",
                    }], (elems_5 = toList(delay(() => collect((matchValue_4) => {
                        let el_16;
                        return singleton((el_16 = SkeletonItem, createElement(el_16, {
                            style: {
                                height: 64,
                            },
                            animation: "wave",
                            shape: "rectangle",
                        })));
                    }, rangeDouble(1, 1, 4)))), ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : singleton(dataFetchFailedView())), delay(() => {
                        let el_76, elems_23, el_74, elems_22, elemsToUse;
                        return singleton((el_76 = Dialog, createElement(el_76, createObj(ofArray([["open", pendingDelete != null], ["modalType", "modal"], ["onOpenChange", (_arg_6, value_1_21) => {
                            if (!value_1_21.open && !isDeleting) {
                                setPendingDelete(undefined);
                            }
                        }], (elems_23 = [(el_74 = DialogSurface, createElement(el_74, createObj(ofArray([["style", {
                            maxWidth: 460,
                        }], (elems_22 = toList(delay(() => {
                            let el_72, elems_21, el_52, elems_16, el_50, el_62, elems_19, elems_18, el_54, el_56, arg_2, locale, formatOptions, arg_3, matchValue_8, elems_17, el_58, el_60, el_70, elems_20, el_64, el_68, el_66;
                            if (pendingDelete != null) {
                                const c_3 = pendingDelete;
                                return singleton((el_72 = DialogBody, createElement(el_72, createObj(singleton_1((elems_21 = [(el_52 = DialogTitle, createElement(el_52, createObj(singleton_1((elems_16 = [(el_50 = Title3, createElement(el_50, {
                                    children: "Fjern fullføring?",
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))]))))), (el_62 = DialogContent, createElement(el_62, createObj(singleton_1((elems_19 = [createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 10 + "px ",
                                }], (elems_18 = [(el_54 = Body1, createElement(el_54, {
                                    children: c_3.Task.Name,
                                })), (el_56 = Caption1, createElement(el_56, {
                                    style: {
                                        color: tokens.colorNeutralForeground3,
                                    },
                                    children: (arg_2 = ((locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_1(c_3.Completed, "dd. MMM yyyy", formatOptions))))), (arg_3 = ((matchValue_8 = c_3.GrantedBy, (matchValue_8 == null) ? "" : (` av ${granterName(matchValue_8)}`))), toText(printf("Godkjent %s%s"))(arg_2)(arg_3))),
                                })), createElement("div", createObj(ofArray([["style", {
                                    padding: ((10 + "px") + " ") + (12 + "px"),
                                    borderRadius: 4,
                                    backgroundColor: tokens.colorStatusWarningBackground1,
                                    border: (((1 + "px ") + "solid") + " ") + tokens.colorStatusWarningBorder1,
                                    display: "flex",
                                    gap: 8 + "px ",
                                    alignItems: "flex-start",
                                }], (elems_17 = [(el_58 = WarningRegular, createElement(el_58, {
                                    fontSize: 16,
                                })), (el_60 = Caption1, createElement(el_60, {
                                    style: {
                                        color: tokens.colorStatusWarningForeground1,
                                    },
                                    children: "Dette kan påvirke brukerens nivå på læringsløp som krever denne oppgaven.",
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_19))]))))), (el_70 = DialogActions, createElement(el_70, createObj(singleton_1((elems_20 = [(el_64 = Button, createElement(el_64, {
                                    appearance: "secondary",
                                    children: "Avbryt",
                                    disabled: isDeleting,
                                    onClick: (_arg_7) => {
                                        setPendingDelete(undefined);
                                    },
                                })), (el_68 = Button, createElement(el_68, {
                                    appearance: "primary",
                                    children: "Fjern",
                                    disabled: isDeleting,
                                    icon: (el_66 = DeleteRegular, createElement(el_66, {})),
                                    onClick: (_arg_8) => {
                                        if (pendingDelete != null) {
                                            const c_1 = pendingDelete;
                                            setIsDeleting(true);
                                            const pr = tap((res) => {
                                                setIsDeleting(false);
                                                if (res.tag === 1) {
                                                    setPendingDelete(undefined);
                                                    errorToast(setCtx, "deleteCompletionNotFound", "Ikke funnet", "Fullføringen finnes ikke lenger", undefined);
                                                }
                                                else {
                                                    setPendingDelete(undefined);
                                                    successToast(setCtx, "deleteCompletionSuccess", "Fullføring fjernet", "");
                                                    fetchHistory(userId, dispatch, setCtx);
                                                }
                                            }, startAsPromise(Task.DeleteCompletion(c_1.Id)));
                                            void (pr.catch((e) => {
                                                setIsDeleting(false);
                                                toastServerError(setCtx, e);
                                            }));
                                        }
                                    },
                                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_20))])))))], ["children", reactApi_1.Children.toArray(Array.from(elems_21))]))))));
                            }
                            else {
                                return singleton(defaultOf());
                            }
                        })), ["children", reactApi_1.Children.toArray(Array.from(elems_22))])]))))], (elemsToUse = ((length(elems_23) <= 2) ? elems_23 : take(2, elems_23)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])))));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_24))])])));
}

//# sourceMappingURL=ListCompletedEvents.jsx.map
